import { SubAPI } from "./SubAPI";
export class ProjectTimeline extends SubAPI {
    list(props) { return this.fetcher.get("/api/project-timeline", props); }
    upsert(props) { return this.fetcher.post("/api/project-timeline/item", props); }
    queryProducts(props) { return this.fetcher.post("/api/product-query/run", props); }
}
